import styled, { css } from 'styled-components';
import rem from 'polished/lib/helpers/rem';
// template components
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Picture from '@nmx/template/dist/componentLibrary/components/Picture';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import SectionContainer from '@nmx/template/dist/componentLibrary/components/SectionContainer';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';

export const ColContentContainerStyled = styled(Col)`
  ${({ theme, reversed }) => {
    const xlargeUp = theme.xlargeUp();
    const largeUp = theme.largeUp();
    const mediumUp = theme.mediumUp();
    let horizontalPadding = 0;

    if (xlargeUp) {
      horizontalPadding = rem(60);
    } else if (largeUp) {
      horizontalPadding = rem(40);
    } else if (mediumUp) {
      horizontalPadding = rem(30);
    }
    return css`
      display: flex;
      flex-direction: column;
      ${reversed ? `padding-right: ${horizontalPadding};` : `padding-left: ${horizontalPadding};`};
    `;
  }}
`;

export const ColPictureContainerStyled = styled(Col)`
  ${({ theme }) => {
    const mediumUp = theme.mediumUp();
    return css`
      margin-bottom: ${mediumUp ? 0 : rem(32)};
      display: flex;
      justify-content: center;
    `;
  }}
`;

export const PictureStyled = styled(Picture)`
 ${({ theme }) => {
    const smallUp = theme.smallUp();
    return css`
      display: block;
      max-width: ${smallUp ? 'unset' : rem(350)};
      @media print {
        display: none;
      }
    `;
  }}
`;

export const RowStyled = styled(Row)`
  ${({ reversed }) => {
    return css`
      flex-direction: ${reversed ? 'row-reverse' : 'row'};
    `;
  }}
`;

export const SectionContainerStyled = styled(SectionContainer)`
  ${({ theme, isLastItem }) => {
    const mediumUp = theme.mediumUp();
    let thisPaddingBottom = mediumUp ? rem(60) : 0;

    if (isLastItem && !mediumUp) {
      thisPaddingBottom = rem(48);
    }

    return css`
      && {
        padding-bottom: ${thisPaddingBottom};
      }
    `;
  }}
`;

export const TypographyStyledHeading = styled(Typography)`
  ${({ theme }) => {
    const mediumUp = theme.mediumUp();
    return css`
      padding-bottom: ${mediumUp ? rem(16) : rem(12)};
      text-align: ${mediumUp ? 'left' : 'center'};
    `;
  }}
`;

export const TypographyTitleStyled = styled(Typography)`
  ${({ theme, disableBottomPadding }) => {
    const mediumUp = theme.mediumUp();
    let paddingBottom = mediumUp ? rem(12) : rem(8);
    if(disableBottomPadding){
      paddingBottom = 0;
    }
    return css`
      padding-bottom: ${paddingBottom};
      text-align: ${mediumUp ? 'left' : 'center'};
    `;
  }}
`;
